import { InitialStateType, SetPosTerminalAction } from '../types';

export const setPosTerminal = (state: InitialStateType, action: SetPosTerminalAction): InitialStateType => ({
  ...state,
  posTerminal: action.payload,
});
